/**
 * exports HTTP status codes
 */

export default {
  NO_CONTENT: 204,
  OK: 200,
};



// WEBPACK FOOTER //
// ./lib/utils/http_status.js